import axios from 'axios';
import { put, takeLatest, call, cps } from 'redux-saga/effects';
import { startSubmit } from 'redux-form';
import { handleLoginService } from '../../Services/handleLocalStorage';
import { RESET_PASSWORD_FIELD } from '../ActionTypes/FormActionTypes';
//types
import * as types from '../ActionTypes/UserActionTypes';
//api
import { user } from '../../BusinessLogic/Network/API/UserApi';
//action
import { UserActionCreators } from '../ActionCreators/UserActionCreators';
import { generateSlugLink } from '../../Utils';

export class UserSaga {
    static *registerStandardUser({ payload: { payload, completion } }) {
        try {
            const _user = user.create();
            yield put(UserActionCreators.clearAuthenticationErrors());

            const { data: response } = yield call(axios, _user.registerUserAccount(payload));
            yield handleLoginService.setAccount({
                access_token: response.meta.token,
                user_id: response.data.id,
            });
            const { fullname, id } = response.data;

            yield put(UserActionCreators.signInUserSuccess(response.data));
            if (completion) yield completion(`/${generateSlugLink({ name: fullname, id })}`);
        } catch (error) {
            yield put(UserActionCreators.registerStandardUserFailed(error));
        }
    }

    static *registerGym({ payload: { payload, completion } }) {
        try {
            const _user = user.create();
            yield put(UserActionCreators.clearAuthenticationErrors());

            const { data: response } = yield call(axios, _user.registerGymAccount(payload));

            yield handleLoginService.setAccount({
                access_token: response.meta.token,
                user_id: response.data.id,
            });
            const { fullname, id } = response.data;

            yield put(UserActionCreators.signInUserSuccess(response.data));
            if (completion) yield completion(`/${generateSlugLink({ name: fullname, id })}`);
        } catch (error) {
            yield put(UserActionCreators.registerGymUserFailed(error));
        }
    }

    static *signIn({ payload: { completionCallback, ...payload } }) {
        try {
            const _user = user.create();
            yield put(UserActionCreators.clearAuthenticationErrors());

            const { data: response } = yield call(axios, _user.logIn(payload));

            handleLoginService.setAccount({
                access_token: response.meta.token,
                user_id: response.data.id,
                fullname: response.data.fullname,
                type: response.data.type,
            });
            const { fullname, id } = response.data;

            if (completionCallback) yield completionCallback(`/${generateSlugLink({ name: fullname, id })}`);
            yield put(UserActionCreators.signInUserSuccess(response.data));
        } catch (error) {
            yield put(UserActionCreators.signInUserFailed(error));
        }
    }

    static *signInWithFacebook({ payload: { social_token } }) {
        try {
            console.log(social_token);
            const _user = user.create();
            const { data: response } = yield call(axios, _user.loginFacebook(social_token));

            if (true) {
                handleLoginService.setAccount({
                    access_token: response.meta.token,
                    user_id: response.data.id,
                });
                const { fullname, id } = response.data;
                yield (window.location.href = `/${generateSlugLink({ name: fullname, id })}`);
                yield put(UserActionCreators.signInUserSuccess(response.data));
            }
        } catch (error) {
            yield put(UserActionCreators.signInUserWithFacebookFailed(error));
        }
    }

    static *signOut({ payload: { deviceId, completionCallback } }) {
        try {
            const _user = user.create();

            yield call(axios, _user.logOut());
            yield put(UserActionCreators.signOutSuccess());
            yield handleLoginService.removeAccount();
            if (completionCallback) yield cps(completionCallback);
        } catch (error) {
            yield put(UserActionCreators.signOutFailed(error));
        }
    }

    static *forgotPassword({ payload }) {
        try {
            yield put(startSubmit(RESET_PASSWORD_FIELD));
            yield put(UserActionCreators.clearAuthenticationErrors());

            const _user = user.create();
            const response = yield call(axios, _user.forgotPassword(payload));

            if (response.status === 200) {
                // yield put(replace('/check-email'));
                // TODO: redirect to another page?
                // TODO: shop popup ?

                yield (window.location.href = '/check-email');
            }
        } catch (error) {
            yield put(UserActionCreators.forgotPasswordFailed(error));
        }
    }

    static *getAuthenticatedUser() {
        try {
            const _user = user.create();
            const { data: response } = yield call(axios, _user.getAuthenticatedUser());
            yield put(UserActionCreators.getAuthenticatedUserSuccess(response.data));
        } catch (error) {
            yield put(UserActionCreators.getAuthenticatedUserFailed(error));
        }
    }

    static *getAuthenticatedUserPreferences() {
        try {
            const _user = user.create();
            const { data: response } = yield call(axios, _user.getUserPreferences());
            yield put(UserActionCreators.getAuthenticatedUserPreferencesSuccess(response.data));
        } catch (error) {
            yield put(UserActionCreators.getAuthenticatedUserPreferencesFailed(error));
        }
    }

    static *deleteUserAccount() {
        try {
            const _user = user.create();
            yield call(axios, _user.deleteUserAccount());
            yield put(UserActionCreators.deleteUserAccountSuccess());
            yield (window.location.href = '/');
        } catch (error) {
            yield put(UserActionCreators.deleteUserAccountFailed(error));
        }
    }
}

export function* saga() {
    yield takeLatest(types.SIGN_IN_USER_REQUEST, UserSaga.signIn);
    yield takeLatest(types.SIGN_OUT_USER_REQUEST, UserSaga.signOut);
    yield takeLatest(types.SIGN_IN_USER_WITH_FACEBOOK_SUCCESS, UserSaga.signInWithFacebook);
    yield takeLatest(types.REGISTER_GYM_USER_REQUEST, UserSaga.registerGym);
    yield takeLatest(types.REGISTER_STANDARD_USER_REQUEST, UserSaga.registerStandardUser);
    yield takeLatest(types.FORGOT_PASSWORD_REQUEST, UserSaga.forgotPassword);
    yield takeLatest(types.GET_AUTHENTICATED_USER_PREFERENCES_REQUEST, UserSaga.getAuthenticatedUserPreferences);
    yield takeLatest(types.GET_AUTHENTICATED_USER_REQUEST, UserSaga.getAuthenticatedUser);
    yield takeLatest(types.DELETE_USER_ACCOUNT_REQUEST, UserSaga.deleteUserAccount);
}



// WEBPACK FOOTER //
// ./src/Store/Saga/UserSaga.js